export default {
  init: function () {
    if (!this.plugins.router) {
      return 'drivers/router/vue-router.4.x.js: router plugin has not been set.'
    }
  },

  beforeEach: function (routerBeforeEach, transitionEach, setTransitions, getAuthMeta) {
    var _this = this

    this.plugins.router.beforeEach(function (to, from) {
      setTransitions({ path: to.path, query: to.query, to: to })

      return new Promise(function (resolve) {
        routerBeforeEach.call(_this, function () {
          var auth = getAuthMeta({ matched: to.matched, to: to })

          transitionEach.call(_this, { path: to.path, query: to.query, to: to, from: from }, auth, function (redirect) {
            if (!redirect) {
              resolve()
              return
            }

            resolve(redirect)
          })
        })
      })
    })
  },

  routerReplace: function (data) {
    this.plugins.router.replace(data)
  },

  routerGo: function (data) {
    var router = this.plugins.router

    if (data.redirect && data.redirect.name === 'Login') {
      router.push(data.redirect).catch(function (err) {
      })
    } else {
      router.push(data.redirect || data).catch(function (err) {
      })
    }
  },
}
